var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-upload-buttom",on:{"click":function($event){return _vm.$emit('on-click')}}},[_c('Icon',{attrs:{"type":"ios-add","size":"34","color":"#cbcbcb"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }